

export default [
  {
    path: '/companies/create',
    name: 'CreateCompanies',
    component: () => import('@/_backoffice/_registrations/components/companies/CreateCompany.vue'),
    meta: {
      auth: true,
      roles: ['Director']
    },
    
  },
  {
    path: '/companies',
    name: 'Companies',
    component: () => import('@/_backoffice/_registrations/components/companies/CompanyList.vue'),
    meta: {
      auth: true,
      roles: ['Director']
    },
    
    children:[
      {
        path: ':id',
        name: 'ShowCompany',
        component: () => import('@/_backoffice/_registrations/components/companies/ShowCompany.vue'),
        meta: {
          auth: true,
          roles: ['Director']
        },
        
      },
    ]
  },



]